/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N90, B400 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var countStyle = css({
  fontSize: 11,
  color: "var(--ds-text-subtlest, ".concat(N90, ")"),
  overflow: 'hidden',
  position: 'relative',
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-100, 8px)", " ", "var(--ds-space-050, 4px)", " 0"),
  lineHeight: '14px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var containerStyle = css({
  display: 'flex',
  flexDirection: 'column'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var highlightStyle = css({
  color: "var(--ds-text-selected, ".concat(B400, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var counterLabelStyle = css({
  fontVariantNumeric: 'tabular-nums'
});